var _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D8EEF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.334 27.875v17.531c0 .82.331 1.608.92 2.188.59.58 1.39.906 2.223.906h23.048c.833 0 1.632-.326 2.222-.906.59-.58.92-1.367.92-2.188V27.875H17.334zm19.905-4.125h2.095c.278 0 .544-.109.74-.302.197-.193.308-.456.308-.73v-6.187c0-.273-.11-.536-.307-.729a1.056 1.056 0 00-.741-.302h-2.095c-.278 0-.545.109-.741.302a1.023 1.023 0 00-.307.73v6.187c0 .273.11.536.307.729.196.193.463.302.74.302zm-12.572 0h2.096c.277 0 .544-.109.74-.302.197-.193.307-.456.307-.73v-6.187c0-.273-.11-.536-.307-.729a1.056 1.056 0 00-.74-.302h-2.096c-.277 0-.544.109-.74.302a1.023 1.023 0 00-.307.73v6.187c0 .273.11.536.306.729.197.193.464.302.741.302z",
    fill: "#028BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.667 22.718v5.156H17.334v-5.156c0-.82.331-1.608.92-2.188a3.168 3.168 0 012.223-.906h3.143v3.094c0 .273.11.536.306.729.197.193.464.302.741.302h2.096c.277 0 .544-.109.74-.302.197-.193.307-.456.307-.73v-3.093h8.381v3.094c0 .273.11.536.307.729.196.193.463.302.74.302h2.096c.278 0 .544-.109.74-.302.197-.193.308-.456.308-.73v-3.093h3.143c.833 0 1.632.326 2.222.906.59.58.92 1.367.92 2.188z",
    fill: "#028BB7"
  })));
}

export default SvgCalendar;